var MODULE = (function(library, $) {
	$(function(){
        $("#selectProductSort").on("change",function() {
			var sortCodeValue = $(this).val();

			var currentUrl = window.location.search;
            currentUrl = library.removeUrlParameter(currentUrl,"sortCode");
            currentUrl = library.removeUrlParameter(currentUrl, "pageNo");
            currentUrl = library.removeUrlParameter(currentUrl, "pageNoFull");
            currentUrl = library.removeUrlParameter(currentUrl, "offset");
            currentUrl = library.removeUrlParameter(currentUrl, "assistant");

            var finalUrl = currentUrl + '&sortCode=' + sortCodeValue;

            window.location.search = finalUrl;
		});
	});
	
	return library;
}(MODULE || {}, jQuery));